// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormStafClinicComponent_wrapper__1AEdf","wrapperForm":"FormStafClinicComponent_wrapperForm__3Wump"};